import { Component, ErrorInfo, ReactNode } from "react";
// import "./ErrorBoundary.css";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false, error: null };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div id="error-page" style={{ gridColumn: `1 / -1` }} className="py-4">
          <div className="content  *:px-4 border-red-200 border rounded-md dark:border-red-950">
            <h4 className="text-lg py-2 bg-red-200  dark:border-red-700/50 text-red-800 dark:bg-red-950 dark:text-red-200">
              Something went wrong
            </h4>

            <div className="py-4 space-y-4  dark:border-mono-700/50 rounded-b-md">
              <p>The page encountered an issue while performing this action.</p>
              <div>
                {this.state.error && (
                  <details style={{ cursor: "pointer" }}>
                    <summary>Read Error</summary>
                    <div className="p-4 border mt-2 space-y-2 bg-white dark:border-mono-700/50  rounded-md dark:bg-mono-925">
                      <code className="text-base">
                        <pre className="whitespace-pre-wrap">
                          {this.state.error.message || "No error message"}
                        </pre>
                      </code>
                      <div>
                        <code className="break-all">
                          <pre className="whitespace-pre-wrap">
                            {this.state.error.stack ||
                              "No Description of error"}
                          </pre>
                        </code>
                      </div>
                    </div>
                  </details>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
export { ErrorBoundary };
export default ErrorBoundary;
